import styled from 'styled-components';
import { Overlay } from '../../styled.js';
import { themeGet } from '../../../v2/foundation/theme/themeGet/get.js';

var StyledOverlay = styled(Overlay).withConfig({
  displayName: "StyledOverlay",
  componentId: "sc-1yq8ljl-0"
})(["border-radius:", ";"], themeGet('borderRadius.circle'));

export { StyledOverlay };
